/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import { useEffect } from 'react';
import Sidebar from '../../../components/Sidebar';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { InputFromUser } from '../../../components/Input/input';
import Header from '../../../components/Header';
import { Select, Spin } from 'antd';
import dayjs from 'dayjs';
import { ActionCreateOccupancy, ActionGetOccupancyByID, ActionUpdateOccupancy } from '../../../store/Actions/occupancyAction';

const { Option } = Select;

const AddOccupancy = () => {
  const dispatch = useDispatch();
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;
  const updateValue = searchParams.get('update');
  const pageValue = (searchParams.get('page')) ? searchParams.get('page') : 1;
  const idValue = searchParams.get('id');
  const isUpdate = updateValue === 'true' && idValue;

  useEffect(() => {
    if (idValue) {
      dispatch(ActionGetOccupancyByID({ Query: `/${idValue}` }, Res => {
      }));
    }
  }, [idValue, dispatch]);
  const { occupancyDetails, loader } = useSelector(state => state?.OccupancyManagement);
  return (
    <>
      <Header />
      <Sidebar />
      <>
        <div>
          <div className="page-wrapper">
            <div className="content">
              {/* Page Header */}
              <div className="page-header">
                <div className="row">
                  <div className="col-sm-12">
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/occupancy">Occupancy</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <i className="feather-chevron-right">
                          <FeatherIcon icon="chevron-right" />
                        </i>
                      </li>
                      <li className="breadcrumb-item active">Add Occupancy</li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="row">
                <div className="col-sm-12">
                  <Spin spinning={!!(loader && idValue)}>
                    <div className="card p-3">
                      <div className="card-body">
                        <Formik
                          enableReinitialize={isUpdate}
                          initialValues={{
                            code: isUpdate ? occupancyDetails?.code : '',                     
                            maxPersons: isUpdate ? occupancyDetails?.maxPersons : '',
                          }}
                          validationSchema={null} // TODO: Add validation schema
                          onSubmit={(values, { setSubmitting, setErrors }) => {
                            const payload = {
                              ...values,
                              
                            };
                            delete payload.dateRange;

                            if (!isUpdate) {
                              dispatch(
                                ActionCreateOccupancy(payload, Res => {
                                  setSubmitting(false);
                                  
                                  if (Res?.status === 200 || Res?.status === 201 || Res?.success) {
                                    window.location.href = `/occupancy?page=${pageValue}`;
                                  } else if (Res?.statusCode === 400) {
                                    setErrors(Res?.data?.errors);
                                  } else {
                                    // window.location.reload();
                                  }
                                })
                              );
                            } else {
                              dispatch(
                                ActionUpdateOccupancy(
                                  {
                                    Query: '/' + idValue,
                                    obj: payload,
                                  },
                                  Res => {
                                    setSubmitting(false);
                                    if (Res?.statusCode === 200 || Res?.statusCode === 201 || Res?.success) {
                                      window.location.href = `/occupancy?page=${pageValue}`;
                                    } else if (Res?.statusCode === 400) {
                                      setErrors(Res?.data?.errors);
                                    } else {
                                      // window.location.reload();
                                    }
                                  }
                                )
                              );
                            }
                          }}
                        >
                          {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            setFieldValue,
                            isSubmitting,
                          }) => {
                            return (
                              <div>
                                <div className="row">
                                  <div className="col-lg-12">
                                    <div className="form-heading">
                                      <h4>Add Occupancy Data</h4>
                                    </div>
                                  </div>

                                  <div className="row">
                                    <InputFromUser
                                      placeholder={'Occupancy Code'}
                                      type="text"
                                      name="code"
                                      onChange={handleChange}
                                      FormGroupClassName={'col-lg-4 col-md-6 col-sm-12'}
                                      LabelClassName={'col-form-label'}
                                      onBlur={handleBlur}
                                      value={values.code}
                                      label="Occupancy Code"
                                      error={errors?.code}
                                      touched={touched.code}
                                    />{' '}
                                    <InputFromUser
                                      placeholder={'max person'}
                                      type="number"
                                      name="maxPersons"
                                      onChange={handleChange}
                                      FormGroupClassName={'col-lg-4 col-md-6 col-sm-12'}
                                      LabelClassName={'col-form-label'}
                                      onBlur={handleBlur}
                                      value={values.maxPersons}
                                      label="max person"
                                      error={errors?.maxPersons}
                                      touched={touched.maxPersons}
                                    />
                            
                                  </div>

                               
                                  <div className="col-12 mt-4">
                                    <div className="doctor-submit text-end">
                                      <button
                                        type="submit"
                                        onClick={() => {
                                          handleSubmit();
                                        }}
                                        className="btn btn-primary submit-form me-2"
                                        disabled={isSubmitting}
                                      >
                                        Submit
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-primary cancel-form"
                                        onClick={() => {
                                          window.location.href = `/occupancy?page=${pageValue}`;
                                        }}
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          }}
                        </Formik>
                      </div>
                    </div>
                  </Spin>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default AddOccupancy;